import { AccountInfo, IPublicClientApplication } from '@azure/msal-browser';
import { queryClient } from 'src/api/queries/queryClient';

export const signOut = (
  instance: IPublicClientApplication,
  account: AccountInfo | null | undefined,
): Promise<void> => {
  sessionStorage.removeItem('assumedUserId');
  queryClient.clear();
  return instance.logoutRedirect({
    account,
    postLogoutRedirectUri: window.location.origin,
  });
};
